import axios from 'axios'
import { CATEGORY_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getAll(page, filter) {
    const params = {
        page,
        filter
    }

    return axios.get(CATEGORY_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${CATEGORY_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(category) {
    return axios.post(CATEGORY_URL, category, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function update(id, category) {
    const url = `${CATEGORY_URL}/${id}`

    return axios.put(url, category, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function deleteCategory(id) {
    const url = `${CATEGORY_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/category.js